import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import LazyRouteElement from './LazyRouteElement';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const AboutTeamPage = lazy(() => import('../pages/about/team/page'));
const InActionPage = lazy(() => import('../pages/about/in-action/page'));
const MilestonesPage = lazy(() => import('../pages/about/milestones/page'));
const CodeOfEthicsPage = lazy(() => import('../pages/code-of-ethics/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const LinksPage = lazy(() => import('../pages/links/page'));
const TestimonialsPage = lazy(() => import('../pages/testimonials/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const AdminDashboardPage = lazy(() => import('../pages/admin/page'));
const AdminSeoPage = lazy(() => import('../pages/admin/seo/page'));
const AdminConsultantsPage = lazy(() => import('../pages/admin/consultants/page'));
const AdminProjectsPage = lazy(() => import('../pages/admin/projects/page'));
const AdminContractsPage = lazy(() => import('../pages/admin/contracts/page'));
const AdminCalendarPage = lazy(() => import('../pages/admin/calendar/page'));
const AdminMilestonesPage = lazy(() => import('../pages/admin/milestones/page'));
const AdminInsightsPage = lazy(() => import('../pages/admin/insights/page'));
const AdminPhotosPage = lazy(() => import('../pages/admin/photos/page'));
const AdminTestimonialsPage = lazy(() => import('../pages/admin/testimonials/page'));
const AdminTimesheetsPage = lazy(() => import('../pages/admin/timesheets/page'));
const AdminBannersPage = lazy(() => import('../pages/admin/banners/page'));
const AdminServicesPage = lazy(() => import('../pages/admin/services/page'));
const AdminStatsPage = lazy(() => import('../pages/admin/stats/page'));
const AdminFinancePage = lazy(() => import('../pages/admin/finance/page'));
const AdminCoreValuesPage = lazy(() => import('../pages/admin/core-values/page'));
const AdminClientTypesPage = lazy(() => import('../pages/admin/client-types/page'));
const AdminLegalPagesPage = lazy(() => import('../pages/admin/legal-pages/page'));
const TermsOfUsePage = lazy(() => import('../pages/terms-of-use/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const InsightsPage = lazy(() => import('../pages/insights/page'));
const InsightDetailPage = lazy(() => import('../pages/insights/InsightDetailPage'));
const PortalDashboardPage = lazy(() => import('../pages/portal/page'));
const PortalProjectsPage = lazy(() => import('../pages/portal/projects/page'));
const PortalClientsPage = lazy(() => import('../pages/portal/clients/page'));
const PortalTimesheetsPage = lazy(() => import('../pages/portal/timesheets/page'));
const PortalCalendarPage = lazy(() => import('../pages/portal/calendar/page'));
const PortalKnowledgeBasePage = lazy(() => import('../pages/portal/knowledge-base/page'));
const PortalInsightsPage = lazy(() => import('../pages/portal/insights/page'));
const CareerPage = lazy(() => import('../pages/career/page'));
const AdminCareersPage = lazy(() => import('../pages/admin/careers/page'));
const AdminCrmPage = lazy(() => import('../pages/admin/crm/page'));
const AdminReferenceClientsPage = lazy(() => import('../pages/admin/reference-clients/page'));
const AdminKnowledgeBasePage = lazy(() => import('../pages/admin/knowledge-base/page'));
const AdminPageHeroesPage = lazy(() => import('../pages/admin/page-heroes/page'));
const AdminContactInfoPage = lazy(() => import('../pages/admin/contact-info/page'));
const AdminSiteModePage = lazy(() => import('../pages/admin/site-mode/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  { path: '/', element: <LazyRouteElement Component={HomePage} /> },
  { path: '/services', element: <LazyRouteElement Component={ServicesPage} /> },
  { path: '/about', element: <LazyRouteElement Component={AboutPage} /> },
  { path: '/about/team', element: <LazyRouteElement Component={AboutTeamPage} /> },
  { path: '/about/in-action', element: <LazyRouteElement Component={InActionPage} /> },
  { path: '/about/milestones', element: <LazyRouteElement Component={MilestonesPage} /> },
  { path: '/code-of-ethics', element: <LazyRouteElement Component={CodeOfEthicsPage} /> },
  { path: '/contact', element: <LazyRouteElement Component={ContactPage} /> },
  { path: '/links', element: <LazyRouteElement Component={LinksPage} /> },
  { path: '/testimonials', element: <LazyRouteElement Component={TestimonialsPage} /> },
  { path: '/login', element: <LazyRouteElement Component={LoginPage} /> },
  { path: '/admin', element: <LazyRouteElement Component={AdminDashboardPage} /> },
  { path: '/admin/seo', element: <LazyRouteElement Component={AdminSeoPage} /> },
  { path: '/admin/consultants', element: <LazyRouteElement Component={AdminConsultantsPage} /> },
  { path: '/admin/projects', element: <LazyRouteElement Component={AdminProjectsPage} /> },
  { path: '/admin/contracts', element: <LazyRouteElement Component={AdminContractsPage} /> },
  { path: '/admin/calendar', element: <LazyRouteElement Component={AdminCalendarPage} /> },
  { path: '/admin/milestones', element: <LazyRouteElement Component={AdminMilestonesPage} /> },
  { path: '/admin/insights', element: <LazyRouteElement Component={AdminInsightsPage} /> },
  { path: '/admin/photos', element: <LazyRouteElement Component={AdminPhotosPage} /> },
  { path: '/admin/testimonials', element: <LazyRouteElement Component={AdminTestimonialsPage} /> },
  { path: '/admin/timesheets', element: <LazyRouteElement Component={AdminTimesheetsPage} /> },
  { path: '/admin/banners', element: <LazyRouteElement Component={AdminBannersPage} /> },
  { path: '/admin/services', element: <LazyRouteElement Component={AdminServicesPage} /> },
  { path: '/admin/stats', element: <LazyRouteElement Component={AdminStatsPage} /> },
  { path: '/admin/finance', element: <LazyRouteElement Component={AdminFinancePage} /> },
  { path: '/admin/core-values', element: <LazyRouteElement Component={AdminCoreValuesPage} /> },
  { path: '/admin/client-types', element: <LazyRouteElement Component={AdminClientTypesPage} /> },
  { path: '/admin/legal-pages', element: <LazyRouteElement Component={AdminLegalPagesPage} /> },
  { path: '/terms-of-use', element: <LazyRouteElement Component={TermsOfUsePage} /> },
  { path: '/privacy', element: <LazyRouteElement Component={PrivacyPage} /> },
  { path: '/insights', element: <LazyRouteElement Component={InsightsPage} /> },
  { path: '/insights/:id', element: <LazyRouteElement Component={InsightDetailPage} /> },
  { path: '/portal', element: <LazyRouteElement Component={PortalDashboardPage} /> },
  { path: '/portal/projects', element: <LazyRouteElement Component={PortalProjectsPage} /> },
  { path: '/portal/clients', element: <LazyRouteElement Component={PortalClientsPage} /> },
  { path: '/portal/timesheets', element: <LazyRouteElement Component={PortalTimesheetsPage} /> },
  { path: '/portal/calendar', element: <LazyRouteElement Component={PortalCalendarPage} /> },
  { path: '/portal/knowledge-base', element: <LazyRouteElement Component={PortalKnowledgeBasePage} /> },
  { path: '/portal/insights', element: <LazyRouteElement Component={PortalInsightsPage} /> },
  { path: '/career', element: <LazyRouteElement Component={CareerPage} /> },
  { path: '/admin/careers', element: <LazyRouteElement Component={AdminCareersPage} /> },
  { path: '/admin/crm', element: <LazyRouteElement Component={AdminCrmPage} /> },
  { path: '/admin/reference-clients', element: <LazyRouteElement Component={AdminReferenceClientsPage} /> },
  { path: '/admin/knowledge-base', element: <LazyRouteElement Component={AdminKnowledgeBasePage} /> },
  { path: '/admin/page-heroes', element: <LazyRouteElement Component={AdminPageHeroesPage} /> },
  { path: '/admin/contact-info', element: <LazyRouteElement Component={AdminContactInfoPage} /> },
  { path: '/admin/site-mode', element: <LazyRouteElement Component={AdminSiteModePage} /> },
  { path: '*', element: <LazyRouteElement Component={NotFoundPage} /> },
];

export default routes;
